'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _marker = require('./marker');

var _marker2 = _interopRequireDefault(_marker);

var _kitsJs = require('kits-js');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MarkerOrderTip = function (_React$Component) {
  _inherits(MarkerOrderTip, _React$Component);

  function MarkerOrderTip(args) {
    _classCallCheck(this, MarkerOrderTip);

    var _this = _possibleConstructorReturn(this, (MarkerOrderTip.__proto__ || Object.getPrototypeOf(MarkerOrderTip)).call(this, args));

    _this.createMarker = _this.createMarker.bind(_this);
    _this.state = {};
    return _this;
  }

  _createClass(MarkerOrderTip, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var preData = JSON.stringify(prevProps.data);
      var data = JSON.stringify(this.props.data);

      if (preData != data || !this.map) {}
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'createMarker',
    value: function createMarker() {
      var self = this;
      var _props = this.props,
          position = _props.position,
          num = _props.num,
          rate = _props.rate,
          name = _props.name,
          rightModule = _props.rightModule,
          order = _props.order,
          _props$visible = _props.visible,
          visible = _props$visible === undefined ? true : _props$visible;

      var point = _kitsJs.bmap.createPoint(position);

      var up = true;

      if (rate) {
        if (rate.indexOf('-') > -1) {
          up = false;
          rate = rate.replace(/-/, '');
        }

        if (rate.indexOf('+') > -1) {
          up = true;
          rate = rate.replace('+', '');
        }

        if (rate.length == 0) {
          rate = '_';
        }
      }

      var custom_overlay = {
        'display': 'flex',
        'justifyContent': 'space-between',
        'background': '#FFFFFF',
        'alignItems': 'stretch',
        'boxShadow': '0 2px 2px 0 rgba(0, 0, 0, 0.22)',
        'borderRadius': '3px 0 0 3px',
        'minWidth': '155px',
        'minHeight': '50px',
        'marginTop': '-25px'
      };
      var order_style = {
        minWidth: '30px',
        background: '#999999',
        color: 'white',
        padding: 'auto 0',
        display: 'flex',
        'justifyContent': 'center',
        'alignItems': 'center'
      };

      if (this.props.active) {
        order_style.background = '#F5533D';
      }

      if (this.props.leftStyle) {
        order_style = _kitsJs.obj.merge(order_style, this.props.leftStyle);
      }

      if (this.props.style) {
        custom_overlay = _kitsJs.obj.merge(custom_overlay, this.props.style);
      }

      var right_style = {
        flex: '1',
        padding: '6px',
        'justifyContent': 'center',
        'alignItems': 'center',
        'fontSize': '12px',
        color: '#8D93A3',
        'letterSpacing': '0.6px'
      };

      if (this.props.rightStyle) {
        right_style = _kitsJs.obj.merge(right_style, this.props.rightStyle);
      }

      var eventKeys = Object.keys(self.props).filter(function (p) {
        return p.indexOf('on') == 0;
      });
      var events = [];
      eventKeys.map(function (key) {
        events.push(_defineProperty({}, key, self.props[key]));
      });

      if (visible) {
        return _react2.default.createElement(_marker2.default, {
          key: JSON.stringify(point) + Math.random(),
          map: this.props.map,
          position: point,
          zIndex: self.props.zIndex // {...this.props}
          // offset={new BMap.Size(-75, -60)}

        }, _react2.default.createElement('div', _extends({
          key: JSON.stringify(point) + Math.random(),
          style: custom_overlay
        }, events), _react2.default.createElement('div', {
          style: order_style
        }, order), _react2.default.createElement('div', {
          style: right_style
        }, !rightModule && _react2.default.createElement('div', null, '  ', num + '(' + rate, up ? _react2.default.createElement('img', {
          style: {
            width: '8px',
            height: 'auto',
            margin: '1px'
          },
          src: '//huiyan.baidu.com/cms/react-bmap/up.png'
        }) : _react2.default.createElement('img', {
          style: {
            width: '8px',
            height: 'auto',
            margin: '1px'
          },
          src: '//huiyan.baidu.com/cms/react-bmap/down.png'
        }), ')'), rightModule ? rightModule : _react2.default.createElement('div', null, '  ', name, ' '))));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var marker = this.createMarker();
      return marker;
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        autoViewport: true
      };
    }
  }]);

  return MarkerOrderTip;
}(_react2.default.Component); // MarkerOrderTip.defaultProps = {
//     name: '无文字',
//     rate: '_',
//     order: 0,
//     num: 0,
//     visible: true,
//     position:[89.430831,32.511366],
//     rightModule:<dom/>,
// }


exports.default = MarkerOrderTip;